.scene {
  position: absolute;
  inset: 0;
  overflow: hidden;
  background:
    radial-gradient(120% 90% at 70% 55%, rgba(40, 52, 66, 0.55), transparent 60%),
    linear-gradient(180deg, #0b0e12 0%, #0e1217 60%, #0b0e12 100%);
}
.canvas {
  display: block;
  width: 100%;
  height: 100%;
}
.hud {
  position: absolute;
  /* Above the page's hero shading, which sits after the scene in the DOM. */
  z-index: 2;
  right: var(--sp-6);
  bottom: var(--sp-6);
  width: 17.5rem;
  padding: var(--sp-4) var(--sp-5);
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: var(--radius-lg);
  background: rgba(11, 14, 18, 0.72);
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  box-shadow: var(--shadow-lg);
  color: var(--text-on-dark);
  font-size: var(--fs-sm);
}
.hudHead {
  display: flex;
  align-items: center;
  gap: var(--sp-2);
  margin: 0 0 var(--sp-3);
  font-weight: 600;
}
.live {
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  background: #46d696;
  box-shadow: 0 0 0 0 rgba(70, 214, 150, 0.6);
  animation: pulse 1.8s var(--ease) infinite;
}
@keyframes pulse {
  70% {
    box-shadow: 0 0 0 7px rgba(70, 214, 150, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(70, 214, 150, 0);
  }
}
.hudMeta {
  margin-left: auto;
  font-weight: 500;
  color: var(--text-muted);
}
.readout {
  display: grid;
  gap: 6px;
  margin: 0;
}
.readout div {
  display: flex;
  justify-content: space-between;
  gap: var(--sp-4);
}
.readout dt {
  color: var(--text-muted);
}
.readout dd {
  margin: 0;
  font-variant-numeric: tabular-nums;
  font-weight: 600;
  color: var(--text-strong);
}
.status {
  margin: var(--sp-3) 0 0;
  padding: 0.35rem 0.6rem;
  border-radius: var(--radius-sm);
  font-weight: 700;
  text-align: center;
  color: #46d696;
  background: rgba(70, 214, 150, 0.12);
  transition:
    color var(--dur) var(--ease),
    background-color var(--dur) var(--ease);
}
.status[data-ok="false"] {
  color: var(--accent-hover);
  background: rgba(248, 128, 0, 0.14);
}
@media (max-width: 47.99rem) {
  .hud {
    display: none;
  }
}

/* ---- story mode (scroll-driven) ------------------------------------------ */
.status[data-ok="wait"] {
  color: var(--text-on-dark-muted);
  background: rgba(255, 255, 255, 0.08);
}
/* The last step's payoff: the readout lights up when the front meets the failing crest. */
.story[data-final] .hud {
  border-color: rgba(255, 140, 20, 0.55);
  box-shadow:
    0 0 0 1px rgba(255, 140, 20, 0.25),
    0 18px 60px rgba(255, 140, 20, 0.18);
  transition:
    border-color var(--dur) var(--ease),
    box-shadow var(--dur) var(--ease);
}
/* Clear of the site's floating accessibility button, which sits in the same corner. */
.story .hud {
  bottom: calc(var(--sp-6) + 4.5rem);
}
@media (max-width: 47.99rem) {
  /* The readout carries the story, so phones keep it: compact, top-right under the floating
     header, with the road drawn to its left (ScanScene's story focal point). */
  .story .hud {
    display: block;
    top: calc(var(--header-h) + 2 * var(--header-margin));
    right: var(--sp-4);
    bottom: auto;
    width: 11.5rem;
    padding: var(--sp-3);
    font-size: 0.8125rem;
  }
  .story .hudMeta,
  .story .readout > div:first-child {
    display: none;
  }
}
